var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTebaLogo2018(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 489 113.4",
    enableBackground: "new 0 0 489 113.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EC6500",
    d: "M489,113.4V93.4h-63.8c-1.7,9.2-3.2,16.9-3.8,19.9H489L489,113.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EC6500",
    points: "321.7,93.4 321.7,113.4 388.8,113.4 384.3,93.4 321.7,93.4  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BA9",
    d: "M354.7,46.4l-4.9-20.6h41.6L404.9,85h0.6l8.5-37.9c4.3-17.2,5.9-21.3,30-21.3c5.2,0,17.4,0,17.4,0 s-3.5,15.9-7.9,33.1c-1.7,6.6-16.1,5.8-15.4-0.3c0.1-0.6,0.8-5.3,1.3-8.5c0.8-4.7-4.7-5.3-5.7-0.6c-0.7,3.4-3.9,20-6.9,35.6H489V0 H321.7v85h60.7l-8.6-38.6L354.7,46.4L354.7,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6500",
    d: "M160.3,47.5h8c8.5,0,17.4,1.7,17.4,12.7c0,9.8-9.6,11.7-17.4,11.7h-8V47.5L160.3,47.5z M160.3,14.1h6.5 c7.7,0,16.3,0.7,16.3,10.5c0,8.7-8.8,10.3-16,10.3h-6.9V14.1L160.3,14.1z M143.3,85.2h29.5c10.6,0,29.8-3.1,29.8-24.4 c0-10.4-7.9-18.2-19.4-19.2v-0.2c10-1.8,16.8-8.8,16.8-18.9c0-18.5-16.3-21.7-27.2-21.7h-29.5V85.2L143.3,85.2z M262.5,52.5h-24.7 L250,17.7h0.2L262.5,52.5L262.5,52.5z M208,85.2h17.5l7.4-19.4h34.2l7.3,19.4h18.8L260.1,0.8H241L208,85.2L208,85.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BA9",
    d: "M24.2,85.2h16.9V14.1h24.2V0.8H0v13.3h24.2V85.2L24.2,85.2z M76.5,85.2h50.1V71.9H93.4V48.2h30.1V34.9H93.4 V14.1h32.9V0.8H76.5V85.2L76.5,85.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTebaLogo2018);
export default __webpack_public_path__ + "static/media/TEBA_Logo_2018.7d5d451014d6c3cfeb07ad7d5aca298c.svg";
export { ForwardRef as ReactComponent };